import _get from 'lodash/get'

export function decodeVariantId(product) {
  return parseInt(    
    _get(product, 'node.variants.edges[0]node.id')
    .split('/').pop()
  )
}

export function getImage(product) {
  return _get(product, 'node.variants.edges[0].node.image.originalSrc');
}